export class  Address {
  street: string;
  number: string;
  box: string;
  zip: string;
  city: string;
  country: string;
}
